import React from 'react';

export const HouseWithError = () => (
  <g xmlns="http://www.w3.org/2000/svg">
    <g
      id="Group_1191-6"
      data-name="Group 1191"
      transform="matrix(19.933299,0,0,19.864194,-10305.603,-1638.2727)"
    >
      <path
        id="House"
        d="M 24.758,1.055 A 0.992,0.992 0 0 0 24.185,1.262 L 1.381,19.055 A 0.992,0.992 0 0 0 2.6,20.62 l 1.373,-1.071 v 26.066 a 0.992,0.992 0 0 0 0.991,0.991 h 13.715 a 0.992,0.992 0 0 0 0.323,0 h 11.575 a 0.992,0.992 0 0 0 0.323,0 h 13.723 a 0.992,0.992 0 0 0 0.991,-0.991 V 19.549 l 1.373,1.071 a 0.99217249,0.99217249 0 1 0 1.22,-1.565 l -7.55,-5.891 c 0,-0.206 0,-0.445 0,-0.755 0,-0.725 0,-1.684 0,-2.639 0,-1.912 0,-3.813 0,-3.813 A 0.992,0.992 0 0 0 39.666,4.966 H 35.7 a 0.992,0.992 0 0 0 -0.991,0.991 c 0,0 0,1.147 0,2.295 0,0.1 0,0.173 0,0.271 L 25.4,1.262 A 0.992,0.992 0 0 0 24.758,1.055 Z m 0.036,2.245 10.29,8.028 a 0.992,0.992 0 0 0 0.98,0.139 l 0.614,-0.792 c 0,0 0.005,-0.053 0.006,-0.064 0.001,-0.011 0,-0.028 0,-0.035 0,-0.007 0,-0.02 0,-0.027 0,-0.007 0,-0.028 0,-0.046 0,-0.037 0,-0.087 0,-0.151 0,-0.127 0,-0.307 0,-0.523 0,-0.431 0,-1 0,-1.578 0,-0.653 0,-0.863 0,-1.305 h 1.983 c 0,0.637 0,1.407 0,2.821 0,0.956 0,1.914 0,2.639 0,0.363 0,0.666 0,0.883 0,0.217 0,0.28 0,0.368 a 0.992,0.992 0 0 0 0.381,0.771 L 43.632,18 v 26.624 h -11.9 V 25.786 H 17.854 V 44.624 H 5.957 V 18 Z m -4.957,24.469 h 9.914 v 16.855 h -9.914 z m 6.94,6.94 a 0.991,0.991 0 1 0 0.991,0.991 0.991,0.991 0 0 0 -0.991,-0.991 z"
        transform="translate(515.993,83.577)"
        fill="#333333"
        opacity="0.2"
      />
      <g
        id="Group_1180"
        data-name="Group 1180"
        transform="translate(92.814,-186.686)"
      >
        <g id="Path" transform="translate(460,303)" fill="#f7dfe6">
          <path
            d="m 9.1855469,17.371098 c -4.5135298,0 -8.18555,-3.672021 -8.18555,-8.1855511 0,-4.5135298 3.6720202,-8.18555 8.18555,-8.18555 4.5135301,0 8.1855511,3.6720202 8.1855511,8.18555 0,4.5135301 -3.672021,8.1855511 -8.1855511,8.1855511 z"
            stroke="none"
            id="path16648"
          />
          <path
            d="m 9.1855469,1.9999962 c -3.9621296,0 -7.1855507,3.2234211 -7.1855507,7.1855507 0,3.9621291 3.2234211,7.1855511 7.1855507,7.1855511 3.9621291,0 7.1855511,-3.223422 7.1855511,-7.1855511 0,-3.9621296 -3.223422,-7.1855507 -7.1855511,-7.1855507 m 0,-2.0000000146973 c 5.0621601,0 9.1855511,4.1233911146973 9.1855511,9.1855507146973 0,5.0621601 -4.123391,9.1855511 -9.1855511,9.1855511 C 4.1233873,18.371098 -3.8146973e-6,14.247707 -3.8146973e-6,9.1855469 -3.8146973e-6,4.1233873 4.1233873,-3.8146973e-6 9.1855469,-3.8146973e-6 Z"
            stroke="none"
            fill="#bf013b"
            id="path16650"
          />
        </g>
        <line
          id="Line_68"
          data-name="Line 68"
          x2="9"
          transform="translate(464.686,312.186)"
          fill="none"
          stroke="#bf013b"
          strokeWidth="2"
          x1="0"
          y1="0"
          y2="0"
        />
      </g>
    </g>
  </g>
);
